/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Define from '../../util/B_Define';
import B_Real from '../base/B_Real';
import B_ChildTool from '../base/B_ChildTool';
import B_Shape from '../shape/B_Shape';
import B_ShapeHeader from '../shape/B_ShapeHeader';
let mix = (superclass) => new MixinBuilder(superclass);

class B_HeaderTimer extends mix(B_Real).with(B_ChildTool, B_Shape, B_ShapeHeader) {
	constructor(inputJson) {
		super(inputJson);

		this._WIDTH = this.CODMOS.CANVAS.width / 2 * 0.8;
		this._container.x = this.CODMOS.CANVAS.width / 2 - this._WIDTH;
		this._HEIGHT = this._WIDTH / 4;

		// [S] shape & icon & text 생성
		// this._fitShape( this._WIDTH, this._HEIGHT, B_Define.SHAPE_BG );
		this._bg = new createjs.Shape();
		this._bg.graphics
			.beginFill('#f5f5f5')
			.drawRoundRectComplex(0, 0, this._WIDTH, this._HEIGHT, 10, 0, 0, 10);
		this._boxShadow = new createjs.Shape();
		this._boxShadow.graphics
			.beginFill('#dbdbdb')
			.drawRoundRectComplex(0, -2, this._WIDTH, this._HEIGHT, 10, 0, 0, 10);
		this._container.addChild(this._boxShadow);
		this._container.addChild(this._bg);

		this[B_Define.TIMER_ICON_ID] = new createjs.Text('TIME', '18px GothamBlack', '#aeadad');
		const { width: iconW, height: iconH } = this[B_Define.TIMER_ICON_ID].getBounds();
		const margin = 15;
		this[B_Define.TIMER_ICON_ID].y = this._HEIGHT / 2 - iconH / 2;
		this[B_Define.TIMER_ICON_ID].x = margin;
		this._container.addChild(this[B_Define.TIMER_ICON_ID]);
		this[B_Define.TIMER_TEXT_ID] = new createjs.Text(B_Define.TIMER_INIT_VALUE, '25px GothamBlack', '#aeadad');
		this[B_Define.TIMER_TEXT_ID].y = this._HEIGHT / 2 - this[B_Define.TIMER_TEXT_ID].getBounds().height / 2;
		this[B_Define.TIMER_TEXT_ID].x = margin * 2 + iconW;
		this._container.addChild(this[B_Define.TIMER_TEXT_ID]);

		this._second = this.CODMOS.timer;
		this[B_Define.TIMER_TEXT_ID].text = this._getMinuteTime(this._second);

		// [W] Timer Watcher 설정
		this._initTimeWatcher();
	}

	// [F] protected

	/**
	 * [Function :: _initTimeWatcher]
	 *
	 * @DES :: Time Watcher 설정하기
	 * @IP1 :: null
	 * @O.P :: null
	 * @S.E ::
	 */
	_initTimeWatcher () {
		this.CODMOS.timerWatchers.push((name, oTime, nTime) => {
			this._second = nTime;
			this[B_Define.TIMER_TEXT_ID].text = this._getMinuteTime(nTime);
		});
	}

	/**
	 * [Function :: _getMinuteTime]
	 *
	 * @DES :: 'second' => 'minute + second'
	 * @IP1 :: numSecond {num}
	 * @O.P :: strRtn {str}
	 * @S.E ::
	 */
	_getMinuteTime (numEntrySecond) {
		let numMinute = parseInt(numEntrySecond / 60);
		let numSecond = parseInt(numEntrySecond % 60);
		if (numMinute < 10) numMinute = `0${numMinute}`;
		if (numSecond < 10) numSecond = `0${numSecond}`;
		return `${numMinute}:${numSecond}`;
	}

	// [F] public

	/**
	 * [Function :: getSecond]
	 *
	 * @DES :: 시간 조회
	 * @S.E :: 초단위로 반환
	 */
	getSecond () {
		return this._second;
	}
}

export default B_HeaderTimer;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_HeaderTimer.js